const doc = [({"en":({"js":({"admin":({"highscore_competitions":({"table":({"the_competition_was_removed_from_the_highscore":"The competition was removed from the highscore"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;